import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { Store } from "../../../../@core/store/store";
import { DYNAMIC_STACK_DATA, RECENTLY_ACCESSED_APPS } from "./dynamic-stack.data";
import {
  AnnouncementsLoadedState,
  AnnouncementsLoadingErrorState,
  AnnouncementsLoadingState,
  calendarConsentLoadedState,
  calendarConsentLoadingErrorState,
  calendarConsentLoadingState,
  CarouselDataLoadedState,
  CarouselDataLoadingErrorState,
  CarouselDataLoadingState,
  DynamicStackLoadedState,
  DynamicStackLoadingErrorState,
  DynamicStackLoadingState,
  getCalendarEventsLoadedState,
  getCalendarEventsLoadingErrorState,
  getCalendarEventsLoadingState,
  profileDataLoadedState,
  profileDataLoadingErrorState,
  profileDataLoadingState,
  RecentlyAccessedAppsLoadedState,
  RecentlyAccessedAppsLoadingErrorState,
  RecentlyAccessedAppsLoadingState,
  RemindersLoadedState,
  RemindersLoadingErrorState,
  RemindersLoadingState,
} from "./dynamic-stack.state";

@Injectable({
  providedIn: "root",
})
export class DynamicStackService extends Store.AbstractService {
  getRecentlyAccessedApps(): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RecentlyAccessedAppsLoadingState());
    }, 0);
    setTimeout(() => {
      output.next(new RecentlyAccessedAppsLoadedState(RECENTLY_ACCESSED_APPS));
      output.complete();
    }, 2000);
    return output;
    const path = environment.api.applications.getAllApplications.endpoint;
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RecentlyAccessedAppsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RecentlyAccessedAppsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  getReminderData(userId) {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new RemindersLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.dynamicStack.remindersData.endpoint,
      { userId }
    );
    // const mockBase = 'http://demo0404819.mockable.io/'
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RemindersLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RemindersLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  getDynamicStackData() {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new DynamicStackLoadingState());
    }, 0);
    setTimeout(() => {
      output.next(new DynamicStackLoadedState(DYNAMIC_STACK_DATA))
    }, 0);
    return output;
    const path = environment.api.dynamicStack.endpoint;
    // const mockBase = 'https://demo2793233.mockable.io/api/'
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new DynamicStackLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new DynamicStackLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  private cacheKey = 'leadership';
  private cacheExpiration = 10 * 60 * 1000; // 10 minutes

  private cacheData(data: any): void {
    localStorage.setItem(this.cacheKey, JSON.stringify({ data, cacheTime: new Date().getTime() }));
  }

  clearAttendanceCache(){
    localStorage.removeItem(this.cacheKey)
  }

  getCarouselImages(){
    const me = this;
    const output = new Subject<Store.State>();


    const path = environment.api.cms.hero.endpoint;

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data)=>{
        output.next(new CarouselDataLoadedState(data));
    })

    return output

  }

  getCarouselData(payloadData) {
    const me = this;
    const output = new Subject<Store.State>();

    const cachedData = JSON.parse(localStorage.getItem(this.cacheKey));
    const now = new Date().getTime();

    // Emit loading state immediately
    setTimeout(() => {
      output.next(new CarouselDataLoadingState());
    }, 0);


    if (cachedData && (now - cachedData.cacheTime < this.cacheExpiration)) {
      setTimeout(() => {
        // Emit cached data first, but do NOT complete the Subject here
        output.next(new CarouselDataLoadedState(cachedData.data));
      }, 0);
    }else{

    const path = environment.api.cms.hero.endpoint;
    me.controller
      .get(path, payloadData, environment.api.core.cmsBase, { Authorization: true })
      .subscribe(
        (data: any) => {
          this.cacheData(data);
          output.next(new CarouselDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new CarouselDataLoadingErrorState(e));
          output.complete();
        }
      );

    }
    return output;


  }

  fetchProfileData(empId) {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new profileDataLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(
      environment.api.profile.userProfile.endpoint,
      { empId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new profileDataLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new profileDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  getAnnouncementsData() {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new AnnouncementsLoadingState());
    }, 0);
    const path = environment.api.cms.announcements.endpoint;
    me.controller
      .get(path, null, environment.api.core.base, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new AnnouncementsLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new AnnouncementsLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  getCalendarEvents(payloadData) {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new getCalendarEventsLoadingState());
    }, 0);
    const path = environment.api.dynamicStack.getCalendarEvents.endpoint;
    me.controller
      .post(path, payloadData, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new getCalendarEventsLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new getCalendarEventsLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  calendarConsent(reqBody): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new calendarConsentLoadingState());
    }, 0);

    const path = environment.api.dynamicStack.calendarConsent.endpoint
    // const path = '/fetch-latest-news';

    me.controller.post(path, reqBody, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new calendarConsentLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new calendarConsentLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
}
